import SkillsIcon from "../assets/skill_icon.png";
import "../styles/skills.css";

const SkillsComponent = ({ skill }) => {
    return (
        <div className="skills-component-container">
            <div className="skills-card">
                <div className="column skills-container">
                    <img className="icon" alt="Skills" src={ skill.active_image_path } />
                    <div className="skill">{`${skill.badge}`}</div>
                </div>
            </div>
        </div>
    )
}

export default SkillsComponent;